import {
  ContactLifeCycleActivity,
  ContactLifeCycleActivityListRequestFilter,
  ContactLifeCycleActivityListRequestSorting,
} from 'modules/domain/contactLifeCycleActivity/types'
import { apiClient } from 'modules/utils/httpClient'
import { endpoints } from 'modules/endpoints'
import { ListResponse } from 'types/api'

export const getContactLifeCycleActivitiesList = (
  filter: ContactLifeCycleActivityListRequestFilter,
  sorting: ContactLifeCycleActivityListRequestSorting,
  page: number,
  pageSize?: number,
) => {
  try {
    return apiClient.get<ListResponse<ContactLifeCycleActivity>>(endpoints.contactLifeCycleActivities(), {
      ...filter,
      ...sorting,
      page: page,
      page_size: pageSize,
    })
  } catch (err) {
    console.error('ContactLifeCycleActivities list fetch error!', err)
    throw err
  }
}

export const getContactLifeCycleActivity = (id: string) => {
  try {
    return apiClient.get<ContactLifeCycleActivity>(endpoints.contactLifeCycleActivities(id))
  } catch (err) {
    console.error('ContactLifeCycleActivity fetch error!', err)
    throw err
  }
}

export const contactLifeCycleActivitiesCount = async (filter: ContactLifeCycleActivityListRequestFilter = {}) => {
  const response = await apiClient.get<ListResponse<ContactLifeCycleActivity>>(endpoints.contactLifeCycleActivities(), {
    ...filter,
    page_size: 1,
  })
  return response.total_count
}
